export enum RoleType {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
}

export enum PostType {
  REGULAR_POST = 'regular_post',
  VIDEO_POST = 'video_post',
}

export enum DistributionType {
  EMAIL = 'email',
  MS_TEAMS = 'ms-teams',
  SLACK = 'slack',
}

export enum PostState {
  PUBLISH = '1',
  SCHEDULED = 'scheduled',
  DRAFT = 'draft',
}

export enum PulsingValue {
  NO_PULSING = 'none',
  MAILS_PER_HOUR = 'per_hour',
  MAILS_PER_DAY = 'per_day',
  DISTRIBUTED_OVER_TIME = 'over_days',
}

export enum ShareType {
  DIRECT_SHARE = 'Direct Share',
  REGULAR_SHARE = 'Regular Share',
  SPLIT_SENDING = 'Split Sending',
}

export enum DateIntervals {
  TODAY = '1d',
  WEEK = '7d',
  MONTH = '30d',
  YEAR = '365d',
  TOTAL = 'allTime',
}

export enum ScoreboardIntervals {
  'Last 24 hours' = '1',
  'Last week' = '7',
  'Last month' = '30',
  'Last quarter' = '90',
  'Last Year' = '365'
}

export enum DateIntervalsUsergroupStats {
  TODAY = '1d',
  WEEK = '7d',
  MONTH = '30d',
  QUARTER = '90d',
  YEAR = '365d',
  TOTAL = 'allTime',
}

export enum DateIntervalsOverview {
  WEEK = '7d',
  MONTH = '30d',
  QUARTER = '90d',
  YEAR = '365d',
  TOTAL = 'allTime',
}

export enum PostActions {
  DELETE = 'delete',
  PUBLISH = 'publish',
  ARCHIVE = 'archive',
}

export enum PostEffectiveness {
  OPEN_AND_ENGAGEMENT = 'open-and-engagement',
  ENGAGEMENT_AND_CLICKS = 'engagement-and-clicks',
}

export enum WatermarkPosition {
  TOP_LEFT = 'top left',
  TOP_CENTER = 'top center',
  TOP_RIGHT = 'top right',
  BOTTOM_LEFT = 'bottom left',
  BOTTOM_CENTER = 'bottom center',
  BOTTOM_RIGHT = 'bottom right',
}

export enum WatermarkColor {
  LIGHT = '#e9ecef',
  GREY = '#adb5bd',
  DARK = '#343a40',
}

export enum WatermarkWeight {
  LIGHT = 'OpenSans-Light.ttf',
  REGULAR = 'OpenSans-Regular.ttf',
  BOLD = 'OpenSans-Bold.ttf',
}

export enum ActivationType {
  RESET = 'reset',
  ACTIVATION = 'activation',
}
